import { ThemeProvider } from 'styled-components'
import { useMainContext } from '../contexts/main'
import { getMainTheme } from '../utils/theme'
import MasterHeader from './MasterHeader'
import { MainBody } from '../styles/CommonStyles'
import Toast from '../components/common/utils/Toast'
import { useWindowSize } from '../hooks/common/useWindowSize'
import { MOBILE_SIZE, TABLET_SIZE } from '../constants/common'
import BottomBar from '../components/common/utils/BottomBar'
import { useEffect, useRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import LayoutSetting from './LayoutSetting'
import useClickOutside from '../hooks/common/useClickOutside'
import FilterContextProvider from '../contexts/filter'
import ConnectionContextProvider from '../contexts/connection'
import BottomDetails from './bottom-bar/BottomDetails'
import { AuthContextProvider } from '../contexts/auth'
import LogoutLoading from '../components/common/loading/LogoutLoading'
import Header from './header/Header'

const MainLayout = ({ children }) => {
    const ref = useRef()
    const lsIconRef = useRef()
    const {
        main: { theme, lang, colorPref },
    } = useMainContext()
    const { width } = useWindowSize()

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])

    const [layoutSettingOpen, setLayoutSettingOpen] = useState(false)
    const closeLayoutSetting = (e) => {
        if (!lsIconRef?.current?.contains(e.target)) {
            setLayoutSettingOpen(false)
        }
    }
    useClickOutside(ref, closeLayoutSetting)

    const openLayoutSetting = (ref) => {
        lsIconRef.current = ref.current
        setLayoutSettingOpen((state) => !state)
    }

    return (
        <ConnectionContextProvider>
            <AuthContextProvider>
                <FilterContextProvider>
                    <ThemeProvider theme={getMainTheme(theme, lang, colorPref)}>
                        {/* <MasterHeader onLayoutSetting={openLayoutSetting} /> */}
                        <Header onLayoutSetting={openLayoutSetting} />
                        <AnimatePresence exitBeforeEnter>
                            {layoutSettingOpen && <LayoutSetting ref={ref} />}
                        </AnimatePresence>
                        <MainBody>{children}</MainBody>
                        <Toast />
                        {width < MOBILE_SIZE && <BottomBar />}
                        {width > TABLET_SIZE && (
                            <BottomDetails id={'bottom-details'} />
                        )}
                        <LogoutLoading />
                    </ThemeProvider>
                </FilterContextProvider>
            </AuthContextProvider>
        </ConnectionContextProvider>
    )
}

export default MainLayout
